import Vue from 'vue'
import AddToCart from './AddToCart.vue'
import vueCustomElement from 'vue-custom-element'

Vue.use(vueCustomElement);

Vue.customElement('add-to-cart', AddToCart, { shadow: false })
